export default "__VITE_ASSET__D4XoV9db__"